import React, { useState } from 'react';
import { MemberInfoType } from 'api/type';
import { invite } from 'api';
import { Toast } from 'react-vant';
import { Level, useIsEn } from '@dana/components';
import { getArgFromUrl, _T } from '@dana/components';

// 定义一个函数组件，接收 props
const CardMessage: React.FC<{
  personData: MemberInfoType;
  type: 'invite' | 'search' | 'show';
  guildId: number;
}> = ({ personData, type, guildId }) => {
  const {
    nickName,
    avatar,
    memberId,
    sex,
    inviteType,
    charmLv,
    wealthLv,
    zoneCode,
    joinTimeStr,
    zoneUrl,
    country,
    danaId,
  } = personData;

  const isEn = useIsEn();

  const [inviteFlag, setInviteFlag] = useState(false);

  const [isInvite] = useState(inviteType === 1);

  const goInvite = async () => {
    if (!isInvite) {
      return;
    }
    if (type === 'invite') {
      const res = await invite(guildId, memberId);
      console.log(41, res);

      if (res) {
        Toast.info(_T('邀请成功'));
        setInviteFlag(true);
      } else {
        Toast.info(_T('邀请失败，请稍后重试'));
      }
    }
  };
  // ${type === 'search' ? 'h-[110px]' : 'h-[90px]'}
  return (
    <div
      className={`flex flex-shrink-0 justify-start items-center mx-auto bg-white mt-[12px] w-[351px] rounded-[8px] py-[16px]`}
      style={{
        direction: isEn ? 'ltr' : 'rtl',
      }}
    >
      <div
        className="mx-[12px] relative w-[66px] h-[66px] rounded-full bg-cover"
        style={{ backgroundImage: `url(${avatar})` }}
      >
        <div
          className="absolute right-0 bottom-0 w-[24px] h-[24px] bg-cover"
          style={{
            backgroundImage: `url(${sex === 2 ? 'https://danachat-other.s3.eu-central-1.amazonaws.com/gift/gift_girl_9bacfc0b1fca35db.png' : 'https://danachat-other.s3.eu-central-1.amazonaws.com/gift/gift_boy_55d08012e45abdb2.png'})`,
          }}
        ></div>
      </div>
      <div className="flex flex-col justify-start items-start ml-[8px]">
        <div
          className="w-[175px] text-[#333] font-sans text-[14px] font-bold leading-[18px] truncate"
          style={{
            textAlign: isEn ? 'left' : 'right',
          }}
          dir="auto"
        >
          {nickName}
        </div>
        <div className="flex justify-center items-center">
          <div className="text-[#B3B3B3] font-sans text-[14px] font-semibold leading-[18px]">
            ID:{danaId}
          </div>
          <div className="mx-[7px] w-[1px] h-[10px] flex-shrink-0 rounded-[4px] bg-[#B3B3B3]"></div>
          <div
            className="mr-[5px] w-[18px] h-[18px] bg-cover font-abeezee"
            style={{
              backgroundImage: `url(${country})`,
            }}
          ></div>
          <div className="text-[#B3B3B3] font-sf-pro-text text-[14px] font-semibold leading-[18px]">
            {zoneCode}
          </div>
        </div>
        <div className="flex justify-start items-center">
          {wealthLv > 0 && <Level type="wealth" level={wealthLv}></Level>}
          {charmLv > 0 && <div className="h-full w-[7px]"></div>}
          {charmLv > 0 && <Level type="charm" level={charmLv}></Level>}
          {/* <LvIcon type='wealth' level={50}></LvIcon>
                    <LvIcon type='charm' level={50}></LvIcon> */}
        </div>
        {type === 'search' && (
          <div className="flex justify-center items-center mt-[6px]">
            <div
              className="w-[80px] h-[18px] bg-cover flex justify-center items-center text-white font-sans text-[12px] rounded-[4px] bg-gradient-to-r from-[#7DD97F] to-[#16B28D]"
              dir="ltr"
            >
              {_T('加入日期')}
            </div>
            <div className="mx-[3px] font-[600] text-[#B3B3B3] font-sans text-[14px] leading-[18px]">
              {joinTimeStr}
            </div>
          </div>
        )}
      </div>
      {type === 'invite' && (
        <div
          onClick={goInvite}
          dir="auto"
          className={`text-white font-sans text-xs font-bold flex justify-center items-center w-[66px] h-[26px] rounded-[74px] bg-gradient-to-r ${isInvite && !inviteFlag ? 'from-[#7DD97F] to-[#16B28D]' : 'from-[#BEECBF] to-[#8BD9C6]'}`}
        >
          {_T('邀请')}
        </div>
      )}
    </div>
  );
};

export default CardMessage;
